import React from 'react';

import PropTypes from 'prop-types';

import { chartProptype, filtersProptype } from '../../../../../utils/proptypes/dashboard/pieChart';
import DashboardWidget from '../DashboardWidget';
import { pieChartConfig } from '../DashboardWidget/configs';

const PieChartCard = ({ chart, onEdit, refresh, filters }) => {
  return (
    <DashboardWidget
      widget={chart}
      onEdit={onEdit}
      refresh={refresh}
      filters={filters}
      config={pieChartConfig}
    />
  );
};

PieChartCard.propTypes = {
  chart: chartProptype.isRequired,
  onEdit: PropTypes.func.isRequired,
  refresh: PropTypes.bool.isRequired,
  filters: filtersProptype.isRequired,
};

export default PieChartCard;
